<template>
  <b-form ref="form" >
    <div class="row">
      <div class="row col-12 pr-0 mb-3">
        <span>Are you sure you want to delete <strong>{{ name }}</strong>?</span>
      </div>
    </div>
  </b-form>
</template>

<script>

export default {
  components: {
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    employment_typeID() {
      let parameters = this.parameters || {}
      return parameters.employment_typeID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  data () {
    return {
      name: '',
      model: {}
    }
  },
  methods: {
    fetchExperienceLevel() {
      let id = this.employment_typeID;
      if (!id) return;

      return this.$store.dispatch('employment_type/find', { id })
      .then(result => {
        if (result && result.data) {
          this.model = result.data;
          this.name = result.data.name;
        }
      })
      .catch(err => console.log(err))
    }
  },
  mounted() {
    if (this.employment_typeID) {
      this.fetchExperienceLevel();
    }
  },
}
</script>
